import React from 'react';
// import { Document,Page } from 'react-pdf/dist/esm/entry.webpack';
// import resume from '../../images/Resume-Portfolio (1).pdf'

export default function Resume() {
  return (
    <div id="resume" >
      <h1>Resume</h1>
      <div className="inner-wrapper">
      <h2>Profile</h2>
        Full stack Web Developer with a Master's degree in Computer science and Bachelor's Degree in Mathematics. Recently earned a certificate in Full Stack Development from Columbia Engineering, New York, and acquired skills in  React, MongoDB, Node, Express, JavaScript, and other web-related technologies 
      <h2>Summary</h2>
      <ul>
        <li>
        Experience with the entire software development life-cycle (SDLC) (design,
development, and deployment), Object Oriented Programming, and agile
software methodologies (scrum).
        </li>
        <li>
        Familiar with developing User Interface (UI) applications using React, Node,
Express, MongoDB, JavaScript, JQuery, HTML5, and CSS3
        </li>
        <li>
        Knowledge of REACT including React.js, Webpack, Redux.
Query. Can develop responsive user interface components using react concepts.
        </li>
        <li>
        Knowledge in using Bootstrap, Bulma, and CSS3 media queries for developing
Responsive web design to support various screen sizes.
        </li>
        <li>
        Experience with analyzing the Document Object Model (DOM) Layout, DOM
Functions, REST API, JSON, and Strong knowledge of Javascript and its libraries.
        </li>
        <li>
        Familiar with web Accessibility standard implementation to make websites
accessible and inclusive for all audiences.
        </li>
        <li>
        Knowledge in implementing SEO practices to make the pages of the website rank
high and searchable for various Search Engines
        </li>
        <li>
        Familiar with optimizing websites for better performance using tools like
Lighthouse, Chrome Developer tool, etc.
        </li>
        <li>
        Proficient in Single Page Application (SPA) design and Responsive design
        </li>
        <li>
        Knowledge of working in an AGILE-based development environment
        </li>
        <li>
        knowledge of code versioning (Git) and control systems and unit testing
        </li>
        <li>
        Knowledge of Data Structures and algorithms
        </li>
        <li>
        Ability to work well in a team or individually on multiple projects
        </li>
        <li>
        Excellent Problem-solving, programming skill, logical skill, and analytical skill, Time
management, Interpersonal, and communication skills
        </li>
        <li>
        Sharp debugging and troubleshooting skills and can Work independently with careful
attention to detail
        </li>
    </ul>
    <h2>Technical Skill</h2>
      <table>
        <tr>
          <td>
            Web Technologies
          </td>
          <td>
            HTML5, CSS3, JavaScript, Bootstrap, SASS, HandleBars (MVC framework)
          </td>
        </tr>
        <tr>
          <td>
          JavaScript Libraries / Frameworks
          </td>
          <td>
            JQuery,  JQueryUI, Node.js, React v.18 and Angular
          </td>
        </tr>
        <tr>
          <td>
          Programming languages
          </td>
          <td>
          JavaScript, Typescript
          </td>
        </tr>
        <tr>
          <td>
            Testing framework
          </td>
          <td>
            jest
          </td>
        </tr>
        <tr>
          <td>
            Web Standards
          </td>
          <td>
            Accessibility, SEO, Progressive Web App, Responsive design
          </td>
        </tr>
        <tr>
          <td>
            Development Tools
          </td>
          <td>
            VS code
          </td>
        </tr>
        <tr>
          <td>
            Version Control
          </td>
          <td>
            GitHub
          </td>
        </tr>
        <tr>
          <td>
            Methodologies
          </td>
          <td>
            Agile, Waterfall
          </td>
        </tr>
        <tr>
          <td>
            Web Servers
          </td>
          <td>
            Express 
          </td>
        </tr>
        <tr>
          <td>
            Database
          </td>
          <td>
            MongoDB, MySQL
          </td>
        </tr>
        <tr>
          <td>
            Operating Systems
          </td>
          <td>
            Windows
          </td>
        </tr>
        <tr>
          <td>
          Bug tracking tool
          </td>
          <td>
          Jira
          </td>
        </tr>
      </table>
   <h2>Experience</h2> 
  <p>CTC group of institutions / Computer Science Teacher
  June 2004 - May 2005,  Calicut, Kerala, India</p>
  <p>I was teaching Computer science subjects (C, Graphics, Java, Computer fundamentals) to polytechnic students.
  </p>
<h2>Education</h2>
<table>
  <tr>
    <th>
      Course
    </th>
    <th>
      Details
    </th>
  </tr>
  <tr>
    <td>
      Columbia Engineering Full stack Web development
    </td>
    <td>
      Columbia Engineering Boot Camps   (Sept 2022- Dec 2022) 
      React, MongoDB, Express, Node, MySQL, PWA, Handlebars, Sequelize, OOP, API, jQuery, JavaScript, Heroku, Git, Bootstrap, CSS, HTML
    </td>
  </tr>
  <tr>
    <td>
       Masters in Computer Science
    </td>
    <td>
      Maharshi Dayanand University (Rohtak, India)
      Software Engineering, Software testing, Artificial intelligence, c++, etc 
    </td>
  </tr>
  <tr>
    <td>
      IBM Web Programming    
    </td>
    <td>
      IBM center Calicut, Kerala, India
      HTML, XML, VBscript, JavaScript, ASP
    </td>
  </tr>
  <tr>
    <td>
      DOEACC A Level 
      Computer Science
    </td>
    <td>
      Department of Electronics and Accreditation of Computer Courses  Kerala, India
      VB, C, Foxpro, Computer Graphics, DBMS, OOP, etc
    </td>
  </tr>
  <tr>
    <td>  
      APGDCA (Advance Post Graduate Diploma in Computer Applications)
    </td>
    <td>
      St. Joseph’s College, Devagiri,  Calicut, Kerala, India
      Java, Oracle, VB, C, Foxpro, Computer Graphics, DBMS, OOP, etc
    </td>
  </tr>
  <tr>
    <td>
      Bachelor of Science (Mathematics)
    </td>
    <td>
      Providence Women’s College,  Calicut, India 
      It is a 3 year bachelor degree course in Mathematics
    </td>
  </tr>
</table>
    </div>
    </div>
  );
}
